const Plumbers = [
  {
    hideHeading: true,
  },
  {
    tag: 'h2',
    heading: 'What jobs can plumbers help with?',
    description: `Plumbers can help with a wide variety of jobs in both commercial and residential spaces. The <a href="https://www.mpaq.com.au/training/courses" target="_blank">Master Plumbers Association of Queensland</a>, for example, provides training in completing the below tasks for would-be plumbers in Queensland.`,

    faqs: [
      {
        tag: 'h3',
        q: `Blocked drains`,
        a: `Blocked drains are a common problem Australian homeowners deal with every year. It’s one of the most troublesome problems, too—a blocked drain can lead to flooding, sewerage leaks, clogged toilets and more.
<br><br>
        Typically, blocked drain problems are complicated and can’t be completed as a simple DIY job—a qualified, licensed plumber is a necessity. Plumbers know how to unblock drains quickly, efficiently and without causing extra damage. Legally, too, only a licensed drainer or plumber can carry out repair or maintenance work on your home drainage system.
        <br><br>
        Blocked drains may be caused by:<br>
        <ul>
        <li>Tree roots.</li>
        <li>Grease build-up.</li>
        <li>Toilet paper or build-up of other hygiene products.</li>
        </ul>
        <br>
        To solve blocked drain issues, a plumber will first identify the cause of the clog. The plumber will then choose the correct piece of equipment to solve the problem.
        <br><br>
        The “electric eel” or motorised drain snake is a common tool used for cutting through tree roots—a flexible, long steel rod with protruding cutters. Since “electric eels” have limited reach and can sometimes damage pipes, many plumbers elect to use modern hydro-jets to clear out drains with high-pressured water.
        <br><br>
        If your pipes have been cracked or otherwise damaged by tree roots, they may need to be replaced. Plumbers may replace the entire pipe, or only a section, depending on the extent of the damage.
        <br><br>
        Plumbers covered by local associations such as <a href="https://www.masterplumbers.asn.au/" target="_blank">The Master Plumbers and Gasfitters Association of Western Australia</a> will have access to full training in unclogging blocked drains and completing other plumbing or gasfitting related tasks.

        `,
      },

      {
        tag: 'h3',
        q: `Drain cleaning`,
        a: `High-pressure water jets used to unclog blocked drains can also help with general drain cleaning. When the plumber inserts the hydro-jet hose into the drain, the water will blast through at a high pressure, completely cleaning out the entire drain.
<br><br>
        Any debris stuck to the pipe’s walls will be blasted away, leaving a clean surface and making it difficult for more debris to start building up. Remember—hydro-jetting can be dangerous, so only a licensed, fully qualified plumber should perform the job.
        `,
      },
      {
        tag: 'h3',
        q: `Fix and install pipes`,
        a: `Plumbers don’t just clean out pipes—they also fix and install them. Plumbers install different kinds of pipes for different residential and commercial needs, including sewer pipes, water pipes and gas pipes.
<br><br>
        In the case of new home or office builds, pipes are installed prior to the construction of walls and flooring. The plumber will reference plans and specifications for all fixtures to ensure pipes are installed in the correct location.
        <br><br>
        Before undertaking this complex job, plumbers will check over the building site to make sure there is enough room to install all necessary ductwork and piping. If any problems are found, the plans may need to be changed slightly.
        <br><br>
        In the case of burst or leaking pipes, plumbers will generally replace the damaged section of pipe. Again, this isn’t an easy job, as new pipe fittings may need to be soldered in place. Best leave it to the experts!

        `,
      },
      {
        tag: 'h3',
        q: `Backflow services`,
        a: `Plumbers also perform backflow services, which ensures drinking water is safe. Backflow prevention devices prevent water from flowing in the wrong direction and contaminating potable water supplies.
        <br><br>
        Plumbers can be hired to check backflow prevention devices to ensure they are working correctly. To undertake a backflow test, plumbers will use a dedicated backflow testing kit to test the backflow system’s pressure. This complicated task is usually performed by a licensed plumber who specialises in backflow prevention systems.
         `,
      },
      {
        tag: 'h3',
        q: `Fix and install bathtubs and toilets`,
        a: `Installing bathtubs and toilets is one of the most commonly known plumbing jobs. This is generally done by plumbers working with new housing, or during bathroom renovations.
        <br><br>
        Generally, the toilet and bathtub will be provided by the homeowner and installed by a licensed plumber. The process of installing a new toilet generally takes about two hours, and involves:
        <br>
        <ul> <li>Disconnecting and turning off the water.</li>
        <li>Checking the shut-off valve is working correctly.</li>
        <li>Drain all water from the old toilet, remove it and check if repairs are needed to the flange (the pipe fitting that mounts the toilet to the floor).</li>
        <li>Placing the new toilet, connecting it to the water and testing to make sure everything works correctly.</li>

       </ul> <br><br>
        The process for installing a new bathtub is similar. It involves:<br>
        <ul> <li>Disconnecting and turning off the water.</li>
        <li>Removing the old bathtub by disconnecting all piping and pulling the tub out (removing a wall section may be necessary).</li>
        <li>Move the new tub into the allocated space (with the drain and water supply pipes aligned accordingly).</li>
        <li>Ensure the tub is level.</li>
        <li>Connect the water supply and drain pipes.</li>
        <li>Seat the tub in plumber’s putty before pressing it into place and tightening the strainer cap.</li>
        <li>Screw the hot and cold taps onto the fittings on the water supply pipes.</li>
        <li>Turn on the water and check for any leaks (make adjustments as required).</li>
        <li>Complete the wall surrounding the tub.</li>
        </ul> <br><br>
        Once the new tub is installed, the surrounding walls can be tiled or painted.
        `,
      },
      {
        tag: 'h3',
        q: `Fix leaking taps`,
        a: `Fixing leaking taps is another common job for plumbers that usually takes about ten minutes. Leaking tap problems should be tackled as quickly as possible, as they can lead to excess water costs and resource waste.
        <br><br>
        Plumbers generally use hydro-seal washers to tighten tapware and will often reseat the tapware to ensure the new washer sits on a clean surface.
        `,
      },
      {
        tag: 'h3',
        q: `Fix or install hot water systems`,
        a: `Plumbers are responsible for both installing and fixing hot water systems. There are two common types of water heater:
        <br><br><br>
        <ul>
        <li>A gas water heater, powered by natural gas</li>
        <li>An electric water heater, powered by electricity</li>
        </ul>
        Propane, hybrid and solar powered water heaters also exist, but are less common. Plumbers are qualified in handling all types of hot water systems.
        <br><br>
        It usually takes a full workday to install a large new hot water heater (between six and eight hours). This time estimate can change depending on how easy it is for the plumber to access the system and its size.
        <br><br>
        To install a new gas water heater, plumbers will:<br>
        <ul> <li>Use the shutoff valve to turn off gas to the heater.</li>
        <li>Turn the main water supply off</li>
        <li>Drain all water in the tank.</li>
        <li>Cut off all water lines.</li>
        <li>Attach the temperature and pressure relief valve.</li>
        <li>Attach copper pipe fittings.</li>
        <li>Attach all water lines.</li>
        <li>Reconnect the vent and gas line.</li>
        <li>Check for any leaks or back drifting.</li>
        </ul>
        <br> Electric water heaters are installed similarly, but power must be turned off to the heater before beginning, and all electrical wires must be disconnected. Generally, this part will be completed by an electrician rather than a plumber.
        `,
      },
      {
        tag: 'h3',
        q: `Gasfitters`,
        a: `Gasfitting involves constructing, installing, replacing, repairing, altering, maintaining and testing any appliances, fittings or other apparatus involved in the use or supply of gas. This can include any roof flashing or sheeting needed for the purpose of this work.
<br><br>
        Gasfitting plumbers are important for maintaining the health and safety of their community. A fully qualified gasfitter must be able to:
        <br>
       <ul>
       <li>Perform gas installations</li>
       <li>Perform LP gas installations in boats and caravans</li>
       <li>Read building and site plans while identifying gas lines</li>
       <li> Understand ventilation requirements</li>
       <li> Understand and apply specifications from the gas appliance manufacturer</li>
       </ul>
        <br><br>
        For Australian and New Zealand-based plumbers, <a href="https://masterplumbersanz.com/training/" target="_blank">Master Plumbers Australia & New Zealand</a> reviews all state-based Master Plumbing Associations to ensure industry all training standards in gasfitting are met.
        `,
      },
      {
        tag: 'h3',
        q: `Sewage system cleaning`,
        a: `When strange noises emanate from the toilet or water bubbles out of the shower, a blocked sewer drain may be the culprit. This is a serious plumbing issue that only qualified plumbers can handle.
        <br><br>
        After identifying the problem with a video camera, plumbers will use chemical drain cleaners, a mechanical drain snake or a hydrojet to clear the blockage.
        <br><br>
        Most Australian households should elect to have their sewer lines cleaned once every 18-22 months to avoid blockages and backups.

        `,
      },
      {
        tag: 'h3',
        q: `Guttering`,
        a: `Licensed plumbers should also be adept in the cleaning, installation and repair of roof downpipes and guttering. Poorly aligned or rusty gutters can cause serious problems for Australian homeowners, including flooding and serious property damage.
<br><br>
        Roof plumbing or stormwater plumbing is a lesser known part of plumbing work. Roof plumbers can:<br>
       <ul> <li>Install and design roof drainage systems.</li>
        <li>Measure, fabricate and install gutters, stormwater disposal systems and downpipes.</li>
        <li>Roof flashing construction.</li>
        </ul>
        <br>
        To prevent roof leaks and mildew problems, homeowners should have a licensed plumber regularly clean their gutters and install mesh coverings and gutter guards to prevent debris buildup.
        `,
      },
    ],
  },
  {
    tag: 'h2',
    heading: 'Types of Plumbers in Australia',
    description: `With all the ways Australian homeowners use water in their day-to-day lives, there is always endless work to be done for plumbers. Plumbers can work on quick projects as small as fixing a leaking tap, to long-term projects laying underground piping for commercial buildings and offices.`,
    faqs: [
      {
        tag: 'h3',
        q: `Commercial Plumbers`,
        a: `Commercial plumbers are responsible for the maintenance and installation of water supply systems and waste removal systems for a variety of commercial spaces, including large housing estates, hotels, businesses and office buildings. This may include the installation and maintenance of:
        <br>
        <ul>
        <li>Sewer and water lines.</li>
        <li>Sprinkler systems.</li>
        <li>Kitchen and bathroom fixtures.</li>
        <li>Drinking fountains.</li>
        <li>Boilers and water heaters.</li>
        </ul>
        <br>
        Commercial plumbing jobs generally begin with excavating trenches, laying pipelines and linking the pipelines to the local mains water and sewerage system. Commercial plumbers must take care to ensure the complex’s water supply is free from contamination.
        <br> <br>
        Once the exterior plumbing is complete, commercial plumbers will move onto interior installations, which can include bathroom and kitchen sinks, toilets, fire sprinklers and drinking fountains.
        <br> <br>
        Commercial plumbers who are members of <a href="https://mpatas.com.au/" target="_blank">Master Plumbers Tasmania</a> must follow a strict code of conduct, ensuring they follow all best trade practices and respect all client contracts.
        `,
      },
      {
        tag: 'h3',
        q: `Residential Plumbers`,
        a: `Residential plumbers generally work on a smaller scale than commercial plumbers, but much of the work is similar. Residential plumbers are responsible for planning, installing, maintaining and repairing all water and gas-based systems in your household.
        <br> <br>
        This may include: <br>
        <ul>
        <li>Excavating trenches and laying pipework for new home builds.</li>
        <li>Installing pipes and fixtures, such as toilets and sinks.</li>
        <li>Installing air-conditioning and heating systems.</li>
        <li>Testing plumbing systems for blockages and leaks.</li>
        <li>Replacing worn-out or broken piping and fixtures.</li>
        </ul>
        <br> <br>
        Master Plumbing associations, such as <a href="https://www.masterplumbers.com.au/mpal-apprentices/" target="_blank">Master Plumbers NSW</a> provide state-based training and support for would-be residential plumbing apprentices and employers.
        `,
      },
      {
        tag: 'h3',
        q: `Emergency Plumbers`,
        a: `Plumbing emergencies are serious plumbing issues that may require immediate attention, in our outside of normal office hours. Common emergency plumbing issues include:
        <br><ul>
          <li>Burst pipes or water leaks, which can lead to flooding and property damage.</li>
        <li>Gas leaks, which can cause fires or health issues.</li>
        <li>A non-functioning hot water system.</li>
        <li>Sewerage back-ups and blockages</li>
        </ul>
        <br>
        Emergency plumbers are well-trained in tackling these serious issues, and are often available on-call 24 hours a day, seven days a week.
        <br> <br>
        Emergency plumbers have access to a range of equipment and replacement parts needed to quickly solve any urgent plumbing issue.
        `,
      },
    ],
  },
  {
    tag: 'h2',
    heading: 'FAQ about Plumbers In Australia',
    faqs: [
      {
        tag: 'h3',
        q: `What equipment do plumbers use?`,
        a: `Plumbers use a huge range of equipment that they will normally store in their specialised truck or van. Plumbers will keep all of this equipment on hand when heading out to a job, as well as extra parts and fittings to account for any unforeseen circumstances.
        <br><br>
        <h4>Drain snake</h4>
        <br>
        A drain snake is a flexible, slender auger used to tackle clogs and blockages. Drain snakes are usually used for especially difficult clogs when a plunger hasn’t worked. Drain snakes should generally only be used by qualified plumbers, as they can cause leaks and tears if used incorrectly.
        <br><br>
        The auger, or uncoiled spring, on the end of the drain snake resembles a corkscrew or drill bit. To use a drain snake, the plumber will directly insert the auger end into the drain, and rotate the handle to uncoil. As the plumber uncoils the snake, the auger will move further down the drain pipe until it reaches the obstruction. The plumber will then rotate the snake to break up the blockage.
        <br><br>
        <h4>Wrench</h4>
        <br>
        Plumbers use pipe wrenches to tighten and loosen pipes and pipe fittings, or basin wrenches to install and remove taps.
        <br><br>
        Basin wrenches have pivoting gripping heads at the end of a long handle, designed to help plumbers reach the awkward space behind a sink. Plumbers will use the basin wrench to loosen or tighten the taps’ mounting nuts or supply tube nuts.
        <br><br>
        Pipe wrenches come in a variety of designs, including:<br>

        <ul>
        <li>Straight pipe wrenches.</li>
        <li>End pipe wrenches.</li>
        <li>Offset wrenches.</li>
        <li>Compound leverage wrenches.</li>
        <li>Chain pipe wrenches.</li>
        <li>Strap wrenches</li>
        </ul>
        <br>
        Straight wrenches are suitable for all kinds of pipe work, while the other wrench types may be used for different piping tasks depending on the angle and accessibility of the work area.
        <br><br>
        <h4>Plunger</h4>
        <br>
        Plungers are often the first tool used to tackle blockages, and many Australian homeowners have one of their own. A plunger uses pressure and suction that, when the handle is moved up and down, the water will be forced up and down too, dislodging any minor clogs.
        <br><br>
        Not all plungers are of the same quality—so if a standard household plunger isn’t working, a plumber may be called upon to fix the blockage with a higher-quality plunger.
        <br><br>
        <h4>Pliers</h4>
        <br>
        Plumber’s pliers are also called tongue and groove pliers, adjustable pliers, multi-grips or channel locks. These specialised pliers have serrated jaws set from 45 to 60 degrees from their handles, allowing the lower jaw to be moved into a number of positions.
        <br><br>
        Plumbing pliers are often used for holding or turning nuts and bolts, clamping materials and gripping difficult objects.
        <br><br>
        <h4>Faucet washers</h4>
        <br>
        Faucet washers can be made from plastic, nylon or rubber, and are designed to stop the water flow when the faucet is closed. Worn-out or cracked faucet washers are a common cause of leaking taps.
        <br><br>
        <h4>Plumber’s tape</h4>
        <br>
        Plumber’s tape or Teflon tape is used to achieve a seal threaded pipe joints, keep the connection lubricated and stop pipes from sticking during disassembly. Plumber’s tape should be used when the threaded connection doesn’t already have a rubber seal built-in.

       `,
      },
      {
        tag: 'h3',
        q: `What can impact the cost of a plumbing job?`,
        a: `The cost of a plumbing job may be impacted by a variety of factors, listed below.
        <br><br>
        <h4>The time required for the job</h4>
        <br>
        Many plumbers charge by the hour, so the cost of the job will change depending on the estimated time taken.
        <br><br>
        <h4>The type of job</h4>
        <br>
        More difficult plumbing jobs that require a more experienced plumber, such as a Master Plumber, may incur higher costs. The installation of a hot water service, for example, will cost much more than the simple job of fixing a leaking tap.
        <br><br>
        <h4>Cost of supplies</h4>
        <br>
        When you hire a plumber, you will need to cover the cost of supplies. This may include equipment, fittings, piping, thread, glue and any other parts needed to get the job done.
        <br><br>
        <h4>Additional trades required</h4>
        <br>
        Some plumbing jobs may require work from additional trades, such as electricians for the installation or removal of an electric water heater, or tilers for bathroom renovations. These additional requirements will add to the overall cost of such work.
        <br><br>
        <h4>Emergency work</h4>
        <br>
        Emergency plumbers will generally charge more than plumbers working during standard businesses hours. For emergency plumbing, expect to pay a call-out fee of $150 to $250, plus the typical hourly rate and material costs.
        `,
      },
      {
        tag: 'h3',
        q: `How to find the best plumber near me`,
        a: `To find a plumber near you, the best option is to use Localsearch, where you can compare reviews, obtain quotes and compare services. Localsearch will match you with a qualified local plumber with experience in your individual plumbing needs. `,
      },
    ],
  },
];

export default Plumbers;
